<script lang="ts" setup>
import { computed, ref } from "vue";
import { breakpointsBootstrapV5, useBreakpoints } from "@vueuse/core";
import { ButtonSize, TuButton, TuIconButton, TuPopover, TuTooltipWrapper, usePopover } from "@tinyurldev/tu-ui-vue";

import QR from "@Components/sharing/QR.vue";
import useTranslation from "@Composables/useTranslation";

interface Props {
  prefix: string;
  url?: string;
}

//
// Setup
const { __ } = useTranslation();
const breakpoints = useBreakpoints(breakpointsBootstrapV5);

//
// Props
withDefaults(defineProps<Props>(), { url: "" });

//
// Data
const isPopoverVisible = ref(false);
const { referenceRef, popoverRef } = usePopover(isPopoverVisible, { placement: "bottom" });

//
// Computed
const isMobileView = breakpoints.smallerOrEqual("xl");

const tooltip = computed(() => {
  if (isPopoverVisible.value) {
    return;
  }

  return __("organization_dashboard.alias_toolbar.qr_code");
});

//
// Methods
function onQrClick(): void {
  isPopoverVisible.value = !isPopoverVisible.value;
}
</script>

<template>
  <div class="v2-qr-dropdown">
    <TuTooltipWrapper :tooltip="tooltip">
      <TuButton
        v-if="!isMobileView"
        ref="referenceRef"
        class="_qr"
        :label="__('organization_dashboard.alias_toolbar.qr')"
        :aria-label="__('organization_dashboard.alias_toolbar.qr_code')"
        :title="__('organization_dashboard.alias_toolbar.qr_code')"
        icon-class="fa-solid fa-qrcode"
        :size="ButtonSize.MEDIUM"
        @click="onQrClick"
      />
      <TuIconButton
        v-else
        ref="referenceRef"
        class="_qr"
        :aria-label="__('organization_dashboard.alias_toolbar.qr_code')"
        :title="__('organization_dashboard.alias_toolbar.qr_code')"
        icon-class="fa-solid fa-qrcode"
        @click="onQrClick"
      />
    </TuTooltipWrapper>

    <TuPopover
      v-show="isPopoverVisible"
      ref="popoverRef"
      class="_popover-wrapper _qr_popover"
    >
      <QR
        class="v2-qr-dropdown__widget _qr_code"
        :qr-test-id="`tinyurl_${prefix}_qrcode_img`"
        :url="url"
      />
    </TuPopover>
  </div>
</template>

<style lang="scss" scoped>
@use "@tinyurldev/tu-ui-vue/scss/settings/spacing.scss" as spacing;

.v2-qr-dropdown {
  &__widget {
    padding: spacing.$xxxs;
  }
}
</style>
